/**
 * Maps IMA content pause/resume cues to the publisher video element.
 * With restoreCustomPlaybackStateOnAdBreakComplete, the integrator must
 * pause/resume content; IMA does not do it automatically.
 *
 * Nonlinear overlay ads play over running content (same as preview-ima.ts).
 */
export function createImaContentSync(video, playback, adFormat) {
  const isOverlay = adFormat === 'overlay';
  return {
    onContentPauseRequested() {
      if (isOverlay) return;
      video.pause();
    },
    onContentResumeRequested() {
      if (isOverlay) return;
      playback.playContent();
    },
  };
}
